/* eslint-disable react/no-array-index-key */
import React from 'react';
import { connect } from 'react-redux';
import Moment from 'moment';

import styles from './lineItem.scss';

const LineItem = props => {
    if (props.invoiceItems) {
        return (
            <div className={styles.lineItemSection}>
                {props.invoiceItems.lineItems && props.invoiceItems.lineItems.map((item, i) => {
                    return (
                        <div className="d-flex flex-row" key={`lineItem-${i}`}>
                            <div className={`flex-grow-1 ${styles.itemName}`}>{item.description}</div>
                            <div className={`align-content-end ${styles.total}`}><span>{item.amount < 0 ? `(${item.currency}${Math.abs(item.amount).toFixed(2)})` : `${item.currency}${item.amount.toFixed(2)}` }</span>
                                {(props.invoiceItems.lineItems.length === 1) && ' USD total' }
                            </div>
                        </div>
                    );
                })}

                {props.invoiceItems.lineItems && (props.invoiceItems.lineItems.length > 1) && props.invoiceItems.total && (
                    <div className="d-flex flex-row">
                        <div className={`flex-grow-1 ${styles.itemName}`}>Final Amount</div>
                        <div className={`align-content-end ${styles.total}`}><span>{props.invoiceItems.total.currency}{props.invoiceItems.total.amount.toFixed(2)} </span> USD total</div>
                    </div>
                )}
                {props.trialAvailability.data.endDate && (
                    <React.Fragment>
                        <hr className={styles.horizontalrow} />
                        <div className="d-flex flex-row">
                            <div className={`flex-grow-1 ${styles.itemName}`}>{props.trialAvailability.data.type === 'fixedLength' ? `Promo ${props.trialAvailability.data.length}-Day Trial` : `Promo Trial until ${Moment(props.trialAvailability.data.endDate).format('MMMM Do, YYYY')}`}</div>
                            <div className={`align-content-end ${styles.total}`}><span>$0.00</span> due today</div>
                        </div>
                    </React.Fragment>

                )}

            </div>
        );
    }

    const symbol = props.symbol || '';
    return (
        <div className={styles.lineItemSection}>
            <div className="d-flex flex-row">
                <div className={`flex-grow-1 ${styles.itemName}`}>{props.itemName}</div>
                <div className={`align-content-end ${styles.total}`}>
                    {/* <span>{symbol}{props.amount}</span>{strikeAmount > 0 ? <span className={`line-through`}>{symbol}{strikeAmount}</span> : ''} total */}
                    <span>{symbol}{props.amount}</span> total

                </div>
            </div>
            {props.trialAvailability.data.endDate && (
                <React.Fragment>
                    <hr className={styles.horizontalrow} />
                    <div className="d-flex flex-row">
                        <div className={`flex-grow-1 ${styles.itemName}`}>{props.trialAvailability.data.type === 'fixedLength' ? `Promo ${props.trialAvailability.data.length}-Day Trial` : `Promo Trial until ${Moment(props.trialAvailability.data.endDate).format('MMMM Do, YYYY')}`}</div>
                        <div className={`align-content-end ${styles.total}`}><span>$0.00</span> due today</div>
                    </div>
                </React.Fragment>

            )}
        </div>
    );
};

const mapStateToProps = ({ trialAvailability }) => {
    return { trialAvailability };
};

export default connect(mapStateToProps, null)(LineItem);
